import isUndefined from 'lodash/isUndefined';
import Breadcrumb from '@Services/Breadcrumb';
import { generateResultsPath } from '@AppRoutes/utils';
import history from '@AppRoutes/history';
import { startGenAIContentProcessingTimer } from '@Containers/Summary/analytics';

// eslint-disable-next-line import/prefer-default-export
export const redirectToResults = (requestParams) => {
  // If requestParams is not set prevent an error to be thrown
  if (isUndefined(requestParams)) {
    return Logger.error('Got redirect request, but lacking parameters. Aborting...');
  }

  // if we haven't set the resetBreadcrumbs in the requestParams it is ok to reset them
  if (isUndefined(requestParams.resetBreadcrumbs) || requestParams.resetBreadcrumbs) {
    Breadcrumb.resetBreadcrumbs();
  }

  // If param is a string containing the value 'back', use the standard browser back functionality.
  if (requestParams === 'back') {
    return window.history.back();
  }

  // Change state with the right parameters, null are optional params
  const params = {
    context: undefined,
    databaseId: undefined,
    order: null,
    pageNumber: 1,
    resultName: undefined,
    // mandatory for 'resolve' of state
    searchId: undefined,
    sort: null,
    // Used for ordering (RXFE-962),
    sortChanged: null,
    description: null,
    hitSetKey: undefined,
    limitOrExclude: '',
  };

  const trackingParams = {
    description: false,
    trackAACustom: true, // default page tracking ignored, custom tracking implemented in controller of the state,
    trackedObj: null, // extended tracked obj for results tracking
    limitOrExclude: '',
    uiDirectives: null, // for the autoExpand of the hopInto search
  };
  const combinedParam = { ...params, ...trackingParams, ...requestParams };
  const pathName = generateResultsPath(combinedParam);

  if (combinedParam.semanticSearchIncluded) {
    startGenAIContentProcessingTimer();
  }

  return history.push({
    pathname: pathName,
    state: {
      ...combinedParam,
    },
  });
};
